export default __webpack_public_path__ + "assets/png/ae327039d2fedba7208cb96ef4336c7a.png";